<div class="pad-2" [style.background-color]="themedata.cardbg">
    <div class="w-100 d-flex jc-center">
        <h2 class="modaltitle {{fontdata.name}}" [style.color]="themedata.color">
            {{ data.title }}
        </h2>
    </div>

    <mat-dialog-actions class="d-flex jc-center">
        <button mat-raised-button class="confirm-button" (click)="navigateToLoginPage()"
            [style.color]="themedata.color" [style.background-color]="themedata.primarytheme">
            {{ "Login again" }}
        </button>
    </mat-dialog-actions>
</div>